import { CrudSorting } from "@refinedev/core";

export const generateWPSort = (sorters?: CrudSorting) => {
  if (sorters && sorters.length > 0) {
    const orderby: string[] = [];
    const order: string[] = [];

    sorters.map((item) => {
      orderby.push(item.field);
      order.push(item.order);
    });

    return {
      orderby,
      order,
    };
  }

  return;
};
